Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("team")) {
        const Team = new Vue({
            el: '#team',
            store,
            data: function () {
                return {
                    ActiveMember: null,
                    HoverMember: null,
                    HoverTeam: false
                }
            },
            computed: {},
            mounted: function () {
                this.initMembers();

                if(Global.Mobile()) {
                    this.ActiveMember = "team-member--1";
                }
            },
            methods: {
                initMembers: function () {

                    var teamMembers = document.getElementById("team").querySelectorAll(".team-member");

                    for (var i = 0; i < teamMembers.length; i++){
                        let teamMember = teamMembers[i];
                        teamMember.addEventListener("click", function () {
                            Team.ActiveMember = teamMember.getAttribute('data-member');
                        });

                        if(!Global.Mobile()) {
                            teamMember.addEventListener("mouseover", function () {
                                Team.HoverMember = teamMember.getAttribute('data-member');
                            });

                            teamMember.addEventListener("mouseleave", function () {
                                Team.HoverMember = null;
                            });
                        }
                    }

                    if(!Global.Mobile()) {
                        document.getElementById("team").addEventListener("mouseover", function () {
                            Team.HoverTeam = true;
                        });

                        document.getElementById("team").addEventListener("mouseleave", function () {
                            Team.HoverTeam = false;
                            Team.ActiveMember = null;
                            Team.HoverMember = null;
                        });
                    }
                },

                closePopup: function(){
                    Team.ActiveMember = null;
                }
            },
            created: function () {
            },
            destroyed: function () {
            }
        });
    }
});